export const QUERY_KEY = {
    FIND_RECENT_COLLEAGUE: "find-recent-colleague",
    GET_APP_DATA: "getAppData",
    GET_ORGANIZER_SETTING: "organizer-setting",
    GET_RESOURCES: "resources",
    GET_RESOURCES_RECOMMENDED: "resources-recommended",
    GET_SELECTED_RESOURCE: "selected-resource",
    GET_ATTENDEE_STATUS: "attendee-status",
    GET_ORGANIZER_ASSISTANT: "organizer-assistant",
    GET_RESOURCES_QUICK: "resources-quick",
    GET_TIMELINE: "timeline",
    SEARCH_RESOURCE: "search-resource",
    FILTER_RESOURCES: "filter-resources",
    FILTER_RESOURCES_FAVORITE: "filter-resources-favorite",
    FILTER_RESOURCES_MOST_USED: "filter-resources-most-used",
    FILTER_RESOURCES_NEARBY: "filter-resources-nearby",
    GET_MEETING_COLLEAGUES: "get-meeting-colleagues",
    GET_FLOORPLAN: "floorplan",
};